/**
 * useIsMobile — Reactive viewport hook that tracks whether the window
 * is below a given breakpoint (default 768px).
 *
 * Delegates to `MobileBreakpointContext` so all consumers in the Community
 * subtree share a single `matchMedia` subscription per breakpoint, instead
 * of attaching one listener per call site (which previously cost 17+ live
 * listeners on the /library cold load).
 *
 * SSR-safe: returns `false` when no provider is in the tree.
 *
 * Breakpoint registration: the surrounding `<MobileBreakpointProvider>`
 * must include every breakpoint any descendant `useIsMobile(bp)` call
 * needs in its `breakpoints` prop. Today the Community pages register
 * `[768, 1280]` at mount.
 */

import { useMobileBreakpoint } from './MobileBreakpointContext'

export default function useIsMobile (breakpoint = 768): boolean {
  return useMobileBreakpoint(breakpoint)
}
